<template>
    <div>
        <base-header type="gradient-indigo" class="pb-6 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">อัพเดทน้ำหนัก {{replaceUpdateFlashMenu || 'Flash Express'}}</h1>
                    <p class="text-white pb-3 px-3">อัพเดทน้ำหนักพัสดุ ใช้สำหรับแก้ไขน้ำหนักพัสดุ ในกรณีที่ขนส่งไม่สามารถแก้ไขน้ำหนักเองได้</p>
                </div>
            </div>
        </base-header>
        <BlockUI v-if="busy">
            <div class="loader"></div>
        </BlockUI>
        <ModalNoti :getShow="modal_noti.show" :submit="closeModalNoti" :getType="modal_noti.type" :getMsg="modal_noti.msg"></ModalNoti>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-lg-12 mb-3">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="row d-flex justify-content-center">
                                            <div class="col-lg-2 d-flex align-items-center">
                                            <h4>หมายเลขติดตามพัสดุ</h4>
                                            </div>
                                        <div class="col-lg-4 d-flex align-items-center">
                                            <div class="form-group col-lg-12">
                                                <small class="form-text text-muted">ตัวอย่าง: TH12345NSW1B</small>
                                                <input
                                                    ref="tracking"
                                                    v-model="tracking_code"
                                                    type="text"
                                                    class="form-control" >
                                                <span class="d-block form-text invalid-feedback" v-if="!$v.tracking_code.required && submitStatus">กรุณากรอก หมายเลขติดตามพัสดุ</span>
                                                <span class="d-block form-text invalid-feedback" v-if="!$v.tracking_code.minLength && submitStatus">หมายเลขติดตามพัสดุ ไม่ถูกต้อง</span>
                                                <span class="d-block form-text invalid-feedback" v-if="!$v.tracking_code.maxLength && submitStatus">หมายเลขติดตามพัสดุ ต้องไม่เกิน {{$v.tracking_code.$params.maxLength.max}} ตัวอักษร</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 d-flex align-items-center">
                                            <button
                                                class="btn btn-info btn-block"
                                                @click="fetchFleOrder()" >
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card-body">
                                    <card shadow type="secondary">
                                        <div slot="header" class="bg-white border-0">
                                            รายละเอียด
                                        </div>
                                        <div class="card-body">
                                            <div class="row align-items-center justify-content-center">
                                                <div class="form-group col-lg-3">
                                                    <h5>น้ำหนัก (กรัม)</h5>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        class="form-control form-control-sm"
                                                        v-model="weight"
                                                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                                        :disabled="isDisable" />
                                                </div>
                                                <div class="col-lg-6 px-5">
                                                    <div class="row align-items-center justify-content-center">
                                                        <div class="form-group col">
                                                            <h5>กว้าง (ซม.)</h5>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                class="form-control form-control-sm"
                                                                v-model="width"
                                                                :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                                                :disabled="isDisable" />
                                                        </div>
                                                        <div class="form-group col">
                                                            <h5>ยาว (ซม.)</h5>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                class="form-control form-control-sm"
                                                                v-model="length"
                                                                :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                                                :disabled="isDisable" />
                                                        </div>
                                                        <div class="form-group col">
                                                            <h5>สูง (ซม.)</h5>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                class="form-control form-control-sm"
                                                                :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                                                v-model="height"
                                                                :disabled="isDisable" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 d-flex align-items-center justify-content-center">
                                                    <button
                                                        :class="['btn px-4' , (isDisable) ? 'btn-primary' : 'btn-danger']"
                                                        :disabled="detail_id == '' "
                                                        @click="disable = !disable">
                                                        {{isDisable ? 'แก้ไข' : 'ยกเลิก'}}
                                                    </button>
                                                    <button
                                                        v-if="!isDisable"
                                                        class ="btn btn-success px-4"
                                                        @click ="updateFleOrder()" >
                                                        บันทึก
                                                    </button>
                                                </div>
                                                <!-- <div class="form-group col-lg-5">
                                                    <h5 class="">สูง</h5>
                                                    <div class="row">
                                                        <div class="col-lg-5">
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                class="form-control form-control-sm"
                                                                :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                                                v-model="height" :disabled="isDisable" />
                                                        </div>
                                                        <div class="col-lg-3 mt-1">
                                                            <button
                                                                :class="['btn btn-block btn-sm mb-3' , (isDisable) ? 'btn-primary' : 'btn-danger']"
                                                                :disabled="detail_id == '' "
                                                                @click="disable = !disable">
                                                                {{isDisable ? 'แก้ไข' : 'ยกเลิก'}}
                                                            </button>
                                                        </div>
                                                        <div class="col-lg-3 mt-1">
                                                            <button
                                                                v-if="!isDisable"
                                                                class ="btn btn-success btn-block btn-sm mb-3 px-3"
                                                                @click ="updateFleOrder()" >
                                                                บันทึก
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <hr class="my-4" />
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <card shadow type="secondary">
                                                        <div slot="header" class="bg-white border-0">
                                                            รายละเอียดพัสดุ (อัพเดท)
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="form-group row">
                                                                <h5 class="col-lg-3">ต้นทุน</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_new.rate)}}
                                                                </label>
                                                                <h5 class="col-lg-3">น้ำหนัก (กรัม)</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_new.weight)}}
                                                                </label>
                                                                <h5 class="col-lg-3">กว้าง (ซม.)</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_new.width)}}
                                                                </label>
                                                                <h5 class="col-lg-3">ยาว (ซม.)</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_new.length)}}
                                                                </label>
                                                                <h5 class="col-lg-3">สูง (ซม.)</h5>
                                                                <label class="col-lg-9">
                                                                    {{checkTextIsEmpty(parcel_details_new.height)}}
                                                                </label>
                                                                <h5 class="col-lg-3">วันที่แก้ไข</h5>
                                                                <label class="col-lg">
                                                                    {{checkTextIsEmpty(parcel_details_new.created_at)}}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </card>
                                                </div>
                                                <div class="col-lg-6">
                                                    <card shadow type="secondary">
                                                        <div slot="header" class="bg-white border-0">
                                                            รายละเอียดพัสดุ (เดิม)
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="form-group row">
                                                                <h5 class="col-lg-3">ต้นทุน</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_old.rate)}}
                                                                </label>
                                                                <h5 class="col-lg-3">น้ำหนัก (กรัม)</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_old.weight)}}
                                                                </label>
                                                                <h5 class="col-lg-3">กว้าง (ซม.)</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_old.width)}}
                                                                </label>
                                                                <h5 class="col-lg-3">ยาว (ซม.)</h5>
                                                                <label class="col-lg-3">
                                                                    {{checkTextIsEmpty(parcel_details_old.length)}}
                                                                </label>
                                                                <h5 class="col-lg-3">สูง (ซม.)</h5>
                                                                <label class="col-lg-9">
                                                                    {{checkTextIsEmpty(parcel_details_old.height)}}
                                                                </label>
                                                                <h5 class="col-lg-3">วันที่สร้าง</h5>
                                                                <label class="col-lg">
                                                                    {{checkTextIsEmpty(parcel_details_old.created_at)}}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </card>
                                                </div>
                                            </div>
                                            <hr class="my-4" />
                                            <div class="form-group row">
                                                <h5 class="col-lg-2">ชื่อผู้ส่ง</h5>
                                                <label class="col-lg-4">
                                                    {{checkTextIsEmpty(senders_name)}}
                                                </label>

                                                <h5 class="col-lg-2">เบอร์โทร</h5>
                                                <label class="col-lg-4">
                                                    {{checkTextIsEmpty(senders_tel)}}
                                                </label>

                                                <h5 class="col-lg-2">ต้นทาง</h5>
                                                <label class="col-lg-4">
                                                    {{checkTextIsEmpty(address_from)}}
                                                </label>

                                                <h5 class="col-lg-2">ปลายทาง</h5>
                                                <label class="col-lg-4">
                                                    {{checkTextIsEmpty(address_to)}}
                                                </label>

                                                <h5 class="col-lg-2">{{$THEME.webTitle}} Tracking Code</h5>
                                                <label class="col-lg-4">
                                                    {{checkTextIsEmpty(tracking_code)}}
                                                </label>

                                                <h5 class="col-lg-2">รหัส Tracking Code ขนส่ง</h5>
                                                <label class="col-lg-4">
                                                    {{checkTextIsEmpty(tracking_code)}}
                                                </label>
                                            </div>
                                        </div>
                                    </card>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
        <ModalConfirm
            ref="confirmWallet"
            :confirm="confirm"
            @confirmModal="confirmModal()"
        />
    </div>
    </template>
    <script>
    import ModalNoti from '@/components/Modals/Modal-noti'
    import validatePop from "../plugins/validatePop.js"
    import { required, minLength, maxLength } from "vuelidate/lib/validators"
    import configPOPTheme from '@/config/POPTheme'
    import ModalConfirm from '@/components/Modals//ModalConfirm'
    import {
        fetchWalletBanlancesToLocalStorage,
        errorWalletUpdateParcel
    } from "@/axios/walletPayment.js"

    const API_URL = process.env.VUE_APP_API

    export default {
        data(){
            return {
                submitStatus: false ,
                busy: false ,
                disable: true ,
                tracking_code: "",
                detail_id: "",
                weight: "" ,
                width: "" ,
                length: "" ,
                height: "" ,
                senders_name:"",
                senders_tel:"",
                replaceUpdateFlashMenu: configPOPTheme.replaceUpdateFlashMenu || 'Flash Express',
                address_from:"",
                address_to:"",
                parcel_details_old:{
                    price: "" ,
                    rate : "" ,
                    cost : "" ,
                    weight: "" ,
                    width: "" ,
                    length: "" ,
                    height: "" ,
                    created_at : ""
                },
                parcel_details_new:{
                    price: "" ,
                    rate : "" ,
                    cost : "" ,
                    weight: "" ,
                    width: "" ,
                    length: "" ,
                    height: "" ,
                    created_at : ""
                },
                modal_noti:{
                    show:false ,
                    msg:'',
                    type:true
                },
                confirm: {
                    show: false,
                    icon: "",
                    emphasize: "",
                    text: "",
                    btnCancelText: "",
                    btnConfirmText: "",
                    isLoad: false,
                },
                isConfirm: false,
                code: null,
                reCheckWallet: false
            }
        },
        components: {
            ModalNoti,
            ModalConfirm
        },
        validations: {
            tracking_code: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(15)
            }

        },
        mounted() {
            this.$nextTick(() => this.$refs.tracking.focus())
            this.tabActive()
        },
        methods:{
            tabActive(){
                window.addEventListener('focus', () => {
                    // on browser tab active
                    if (this.reCheckWallet) {
                        this.reCheckWallet = false
                        console.log('🥝 3')
                        fetchWalletBanlancesToLocalStorage().then( res => {
                            this.$WALLET.balance           = res.balance
                            this.$WALLET.peg_balance       = res.peg_balance
                            this.$WALLET.available_balance = res.available_balance
                        })
                    }
                });
            },
            openModalConfirmWallet(code , credit){
                this.confirm.show = true
                this.confirm.icon = '<i class="fas fa-exclamation-triangle text-yellow fa-2x"></i>'
                this.confirm.emphasize = `ยืนยันการแก้ไขน้ำหนักพัสดุ ?`
                if( code === errorWalletUpdateParcel.CREDIT_MORE_THAN ){
                    this.confirm.text = `หากน้ำหนักพัสดุที่อัพเดท มีน้ำหนัก<span class="text-yellow">มากกว่า</span>พัสดุเดิม <br/>ระบบจะทำการ<span class="text-red">ตัดยอด</span>ส่วนต่างของต้นทุนจำนวน ${credit} บาทจากเครดิตของคุณ `
                }else if( code === errorWalletUpdateParcel.CREDIT_LESS){
                    this.confirm.text = `หากน้ำหนักพัสดุที่อัพเดท มีน้ำหนัก<span class="text-yellow">น้อยกว่า</span>พัสดุเดิม <br/>ระบบจะทำการ<span class="text-yellow">คืนยอด</span>ส่วนต่างของต้นทุน เป็นเครดิตจำนวน ${credit} บาท <br/>เข้าวอลเลตของคุณ `
                }
                this.confirm.text = this.confirm.text + "<br/>คุณยืนยันที่จะแก้ไขน้ำหนักพัสดุ ใช่หรือไม่ ?"
                this.confirm.btnCancelText = 'ยกเลิก'
                this.confirm.btnConfirmText = 'ยืนยัน'
                this.code = code
            },
            openModalConfirmTopUpWallet(){
                this.confirm.show = true
                this.confirm.icon = '<i class="fas fa-exclamation-triangle text-yellow fa-2x"></i>'
                this.confirm.emphasize = `ยอดเครดิตของคุณไม่เพียงพอ กรุณาเติมเครดิต`
                this.confirm.text = ''
                this.confirm.btnCancelText = 'ยกเลิก'
                this.confirm.btnConfirmText = 'เติมเครดิต'
                this.code = errorWalletUpdateParcel.TOPUP
            },
            confirmModal(){
                if(this.code === errorWalletUpdateParcel.TOPUP){
                    this.reCheckWallet = true
                    window.open('/topupcredit','_blank')
                }else if( [
                        errorWalletUpdateParcel.CREDIT_LESS,
                        errorWalletUpdateParcel.CREDIT_MORE_THAN
                    ].includes(this.code) )
                {
                    this.isConfirm = true
                    this.updateFleOrder()
                }
                this.$refs.confirmWallet.closeModalConfirm();
                this.isConfirm = false
                this.code = null;
            },
            fetchFleOrder(){
                this.handleLoader()
                this.$v.tracking_code.$touch()
                if( this.$v.tracking_code.$invalid ){
                    this.submitStatus = true
                    this.handleLoader()
                    return false
                }
                this.submitStatus = false
                this.$http.post(
                    API_URL + "/order/fle/fetch",
                    {
                        query: this.tracking_code
                    },
                    {
                        headers: {
                        Token: localStorage.getItem("access_token")
                        }
                    }
                    )
                    .then(results => {
                        let res = results.data.data
                        if( res && results.data.status == true ){
                            this.detail_id = res.detail_id
                            this.address_from = this.setAddress( res.order.from )
                            this.address_to = this.setAddress( res.order.to )
                            this.senders_name = res.order.senders_name
                            this.senders_tel = res.order.senders_tel
                            this.tracking_code = res.order.tracking_code
                            this.parcel_details_old = res.order_log_update.parcel
                            this.parcel_details_new = res.order_log_update.parcel_update
                            this.setLastParcel( res.order_log_update.parcel , res.order_log_update.parcel_update )
                        }else{
                            let checkError = validatePop( results )
                            this.setModalNoti( true , false , checkError.msg )
                            if( checkError.msg == "ไม่พบข้อมูล หรือ ไม่สามารถแก้ไขรายการนี้ได้" ){
                                this.defaultState()
                            }
                        }
                        this.isConfirm = false
                        this.handleLoader()
                    })
            },
            updateFleOrder(){
                this.handleLoader()
                this.handleDisable()
                this.$http.put(
                    API_URL + `/order/fle/${this.detail_id}`,
                    {
                        parcel: {
                            weight: this.weight ,
                            width: this.width ,
                            length: this.length ,
                            height: this.height ,
                        },
                        is_confirm: this.isConfirm
                    },
                    {
                        headers: {
                        Token: localStorage.getItem("access_token")
                        }
                    }
                    )
                    .then(results => {
                        if( results.data.status == true ){
                            this.setModalNoti( true , true , 'อัพเดทข้อมูลเสร็จสิ้น')
                            let res = results.data.data
                            this.parcel_details_new = res.order_log_update.parcel_update
                        }else{
                            if(results.data.error.code === errorWalletUpdateParcel.NOT_ENOUGH_BALANCE ){
                                this.openModalConfirmTopUpWallet()
                            }else if( [
                                errorWalletUpdateParcel.CREDIT_LESS,
                                errorWalletUpdateParcel.CREDIT_MORE_THAN
                                ].includes(results.data.error.code) )
                            {
                                this.openModalConfirmWallet(results.data.error.code , results.data.error.credit)
                            }else{
                                let checkError = validatePop( results )
                                this.setModalNoti( true , false , checkError.msg )
                            }
                        }
                        this.handleLoader()
                    })

            },
            setModalNoti( show , type , msg ){
                this.modal_noti.show = show
                this.modal_noti.type = type
                this.modal_noti.msg = msg
            },
            setAddress( address ){
                if( !address ){
                    return ''
                }
                return address.address +' '+ address.state +' '+ address.district +' '+ address.province
                +' '+ address.postcode
            },
            setLastParcel( original  , update ){
                if( update.weight > 0 ){
                    this.weight = update.weight
                    this.width = update.width
                    this.length = update.length
                    this.height = update.height
                }else{
                    this.weight = original.weight
                    this.width = parseInt(original.width)
                    this.length = parseInt(original.length)
                    this.height = parseInt(original.height)
                }
            },
            defaultState(){
                this.tracking_code  = ""
                this.detail_id      = ""
                this.weight         = ""
                this.width          = ""
                this.length         = ""
                this.height         = ""
                this.senders_name   = ""
                this.senders_tel    = ""
                this.tracking_code  = ""
                this.address_from   = ""
                this.address_to     = ""
                for( let key in this.parcel_details_old ){
                    this.parcel_details_old[key] = ''
                }
                for( let key in this.parcel_details_new ){
                    this.parcel_details_new[key] = ''
                }
            },
            checkTextIsEmpty( text ){
                return text ? text : '-'
            },
            handleDisable(){
                this.disable = !this.disable
            },
            handleLoader(){
                this.busy = !this.busy
            },
            closeModalNoti(){
                this.modal_noti.show = false
            }
        },
        computed:{
            isDisable(){
                return this.disable ? true : false
            }
        }
    }
    </script>
    <style lang="scss">
        .table-custom-color .table .thead-dark th {
            color: #ffffff;
        }
        .validate-custom-fix-parcel {
            display: block;
            position: absolute;
            top: 80%;
        }

    </style>
